export default "__VITE_ASSET__9904a40d__"